export const WorkExperienceList = [
  {
    company: "MSC Mediterranean Shipping Company",
    position: "Fullstack Engineer",
    duration: "August 2026 - June 2027",
    responsibilities: [
      `Architect a payment solution to process around IDR 1T+ in monthly transactions and reduce finance team workload from manual payment checking into semi-automated payment checking.`,
      `Hold cross-functional discussions with Finance and Business Process teams to map core business requirements and align operational expectations.`,
      `Ensure security compliance with Indonesian regulatory frameworks while maintaining alignment with Geneva security standards.`
    ],
  },
  {
    company: "Moladin",
    position: "Fullstack Engineer Intern | IoT Team",
    duration: "September 2025 - August 2026",
    responsibilities: [
      `Built a Vehicle Management System for managing inventory, tagging, application gateway, alert system, and tracking GPS location analytics supported by a network of 20,000+ GPS-enabled IoT devices.`,
      `Designed and implemented support for 2+ car loan product types within the IoT Vehicle Management System, enabling broader business integration and operational flexibility.`,
      `Handed over ownership of 4+ production service modules, including IoT Alert System, Traccar Gateway, and others, following the resignation of the technical lead, ensuring uninterrupted operations and continued feature development.`,
      `Identified a critical vulnerability in the Device Acceptance App authentication system, preventing the company from losing IDR 9 million per month.`,
      `Configured and optimized an IoT server supporting multiple GPS protocols, including GT06 and H02.`,
      `Identified and applied a more cost-efficient FCM notification delivery solution, reducing monthly operational costs by approximately IDR 4 million.`,
      `Developed and tested core marketplace features supporting Moladin.com's transition from a used-car marketplace to a new-car marketplace, contributing to the successful launch of a platform offering 400+ new car models.`
    ],
  },
  {
    company: "99 Group",
    position: "Backend Engineer Intern",
    duration: "February 2025 - May 2025",
    responsibilities: [
      `Architected scalable and high-performance microservice APIs for a property e-commerce platform using Go, gRPC, and GraphQL, achieving over 200% improvement in response time compared to the previous monolith architecture.`,
      `Constructed an email saved search recommendation notification system that potentially increased email click-through rate (CTR) by 2.5%, enabling users to receive personalized property updates based on their saved preferences.`,
      `Reduced CI/CD unit testing time by 23% by analyzing data synchronization workflows and converting repetitive Elasticsearch test data into reusable seed data.`,
      `Developed backend services and API enhancements supporting Rumah123 property platform initiatives.`
    ],
  },
  {
    company: "Bina Nusantara IT Division",
    position: "Fullstack Engineer",
    duration: "March 2023 - February 2024",
    responsibilities: [
      `Developed education technology solutions through Learning Management System development, supporting Binus University's academic and operational requirements.`,
      `Built high-performance and scalable backend infrastructure to support the learning management process.`,
      `Implemented interactive components and features to enhance student engagement and facilitate seamless learning experiences.`
    ],
  }
];
